import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import { PlanBlockedDialog, PlanBanner } from './PlanGate';
import Orders from './Orders';
import TakeOrder from './TakeOrder';
import '../style/partnercafeview.css'
import EditCafeDetails from './EditCafeDetails';
import FinanceStats from './FinanceStats';
import FinanceDashboard from './Finance';
import TransactionView from './TransactionView';
import Inventory from './Inventory';
import LiveMenu from './LiveMenu';
import TableManager from './TableManager';
import Growth from './Growth';
import Dashboard from './Dashboard';
import Expense from './Expense';
import RecipeManager from './RecipeManager';
import PaymentGatewaySettlement from './PaymentGatewaySettlement';
import TableQRManager from './TableQRManager';
import Offers from './Offers';
import AnimatedIcon from './icons/AnimatedIcon';
import { host } from '../script/variables';

// ── KOM Settings panel ────────────────────────────────────────────────────────
function KomSettings({ cafeid }) {
  const token = localStorage.getItem('partnertoken');
  const [komEnabled, setKomEnabled] = useState(false);
  const [loading, setLoading]       = useState(true);
  const [saving, setSaving]         = useState(false);
  const [msg, setMsg]               = useState(null);

  useEffect(() => {
    fetch(`${host}/partner/cafe-settings?cafeId=${cafeid}`, {
      headers: { Authorization: token },
    })
      .then(r => r.json())
      .then(d => setKomEnabled(Boolean(d.komEnabled)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [cafeid, token]);

  const toggle = async () => {
    setSaving(true);
    setMsg(null);
    try {
      const r = await fetch(`${host}/partner/toggleKom`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ cafeId: cafeid, enabled: !komEnabled }),
      });
      const d = await r.json();
      if (d.success) {
        setKomEnabled(d.komEnabled);
        setMsg({ type: 'success', text: `Kitchen terminal ${d.komEnabled ? 'enabled' : 'disabled'}.` });
      } else {
        setMsg({ type: 'error', text: d.msg || 'Failed to update.' });
      }
    } catch {
      setMsg({ type: 'error', text: 'Network error.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: '32px', maxWidth: 520 }}>
      <h2 style={{ marginBottom: 6, fontSize: '1.2rem' }}>Terminal Settings</h2>
      <p style={{ color: '#666', marginBottom: 28, fontSize: '0.9rem' }}>
        Control how orders flow between the Reception (ROM) and Kitchen (KOM) terminals.
      </p>

      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: '#f9f9f9', border: '1px solid #e5e5e5', borderRadius: 12,
        padding: '18px 20px',
      }}>
        <div>
          <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>Kitchen Order Management (KOM)</div>
          <div style={{ fontSize: '0.82rem', color: '#888', marginTop: 4 }}>
            {komEnabled
              ? 'ROM shows "waiting for kitchen" — KOM manages Preparing & Ready.'
              : 'ROM handles all statuses directly. KOM terminal has no special role.'}
          </div>
        </div>
        <button
          onClick={toggle}
          disabled={loading || saving}
          style={{
            marginLeft: 24,
            width: 52, height: 28,
            borderRadius: 14,
            border: 'none',
            cursor: loading || saving ? 'not-allowed' : 'pointer',
            background: komEnabled ? '#10b981' : '#d1d5db',
            position: 'relative',
            transition: 'background 0.2s',
            flexShrink: 0,
          }}
        >
          <span style={{
            position: 'absolute',
            top: 3, left: komEnabled ? 27 : 3,
            width: 22, height: 22,
            borderRadius: '50%',
            background: '#fff',
            transition: 'left 0.2s',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          }} />
        </button>
      </div>

      {msg && (
        <div style={{
          marginTop: 16, padding: '10px 14px', borderRadius: 8, fontSize: '0.85rem',
          background: msg.type === 'success' ? '#d1fae5' : '#fee2e2',
          color: msg.type === 'success' ? '#065f46' : '#991b1b',
        }}>
          {msg.text}
        </div>
      )}

      {komEnabled && (
        <div style={{ marginTop: 20, padding: '14px 16px', background: '#eff6ff', borderRadius: 8, fontSize: '0.83rem', color: '#1e40af' }}>
          <strong>KOM is active.</strong> Kitchen staff should log in at{' '}
          <code style={{ background: '#dbeafe', padding: '1px 6px', borderRadius: 4 }}>
            kom.restropilots.com
          </code>{' '}
          with an employee account that has <code style={{ background: '#dbeafe', padding: '1px 6px', borderRadius: 4 }}>orders:update</code> permission.
        </div>
      )}
    </div>
  );
}

const NAV_ITEMS = [

  { view: -1, label: 'Dashboard',        icon: 'dashboard', isLocked: false },
  { view: 0,  label: 'Orders',           icon: 'orders',    isLocked: false },

  // { view: 2,  label: 'Take Order',       icon: 'orders',    isLocked: false },
  { view: 3,  label: 'Sales & Finance',          icon: 'finance',   isLocked: false },
  // { view: 4,  label: 'Transactions',     icon: 'finance',   isLocked: false },
  // { view: 5,  label: 'Settlements',      icon: 'finance',   isLocked: false },

  { view: 7,  label: 'Live Menu',        icon: 'menu',      isLocked: false },
  { view: 8,  label: 'Table Manager',    icon: 'table',     isLocked: false },
  { view: 10, label: 'Expenses',         icon: 'expense',   isLocked: false },
  { view: 9,  label: 'Growth',           icon: 'growth',    isLocked: false },
  { view: 12, label: 'QR Studio',        icon: 'link',      isLocked: false },
  { view: 15, label: 'Terminal Settings',icon: 'bulb',  isLocked: false },
  { view: 1,  label: 'Edit Details',     icon: 'edit',      isLocked: false },
  // { view: 6,  label: 'Inventory',        icon: 'frame',     isLocked: true  },

  // { view: 14, label: 'Discounts & Offers', icon: 'frame',   isLocked: true },
  // { view: 11, label: 'Recipe Manager',   icon: 'cafe',      isLocked: true  },
  // { view: 13, label: 'AI Insights',      icon: 'bulb',      isLocked: true },

];

const LockIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginLeft: '5px', opacity: 0.55, flexShrink: 0 }}
    aria-label="Locked feature"
  >
    <rect x="1" y="5.5" width="9" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
    <path d="M3 5.5V3.5a2.5 2.5 0 0 1 5 0v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const PartnerCafeView = ({ socket }) => {
  const { cafeid } = useParams();
  const [mainView,    setMainView]    = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigate = (view, isLocked) => {
    if (isLocked) return;
    setMainView(view);
    setSidebarOpen(false);
  };

  return (
    <div className="container">

      {/* ── Mobile hamburger ── */}
      <button
        className="mobile-menu-toggle"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Toggle menu"
      >
        <AnimatedIcon name={sidebarOpen ? 'menu-close' : 'menu-open'} size={16} />
      </button>

      {/* ── Tap-outside overlay (mobile) ── */}
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'visible' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* ── Sidebar ── */}
      <div className={`sidebar ${sidebarOpen ? 'active' : ''}`}>
        <Link to="/partner" className="back-link">← Back to Dashboard</Link>

        {NAV_ITEMS.map(({ view, label, icon, isLocked }) => (
          <button
            key={view}
            className={`${mainView === view ? 'active' : ''} ${isLocked ? 'locked' : ''}`}
            onClick={() => navigate(view, isLocked)}
            disabled={isLocked}
            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            <AnimatedIcon name={icon} size={17} />
            {label}
            {isLocked && <LockIcon />}
          </button>
        ))}
      </div>

      {/* ── Main content ── */}
      <div className="main">
        <PlanBlockedDialog />
        <PlanBanner cafeId={cafeid} />
        {mainView === -1 && <Dashboard     cafeid={cafeid} />}
        {mainView === 0  && <Orders        cafeid={cafeid} socket={socket} />}
        {mainView === 1  && <EditCafeDetails cafeid={cafeid} />}
        {mainView === 2  && <TakeOrder     cafeid={cafeid} />}
        {mainView === 3  && <FinanceDashboard  cafeid={cafeid} />}
        {mainView === 4  && <TransactionView cafeid={cafeid} />}
        {mainView === 5  && <PaymentGatewaySettlement cafeid={cafeid} />}
        {mainView === 6  && <Inventory     cafeid={cafeid} />}
        {mainView === 7  && <LiveMenu      cafeid={cafeid} />}
        {mainView === 8  && <TableManager  cafeid={cafeid} />}
        {mainView === 9  && <Growth        cafeid={cafeid} />}
        {mainView === 10 && <Expense       cafeid={cafeid} />}
        {mainView === 11 && <RecipeManager cafeid={cafeid} />}
        {mainView === 12 && <TableQRManager cafeid={cafeid} />}
        {/* {mainView === 13 && <TableQRManager cafeid={cafeid} />} */}
        {mainView === 14 && <Offers cafeid={cafeid} />}
        {mainView === 15 && <KomSettings cafeid={cafeid} />}
      </div>
    </div>
  );
};

export default PartnerCafeView;